<template>
  <div :id="$style.users">
    <Header />
    <h1>Users</h1>
    <div :class="$style.body">
      <div :class="[$style.block]">
        <h1>Edit User</h1>
        <hr/>
        <edit />
      </div>
      <div :class="[$style.block, $style.short]">
        <list />
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '../lib/Header'
  import list from './list'
  import edit from './edit'

  export default {
    name: 'Users',
    components: {
      Header,
      list,
      edit
    }
  }
</script>

<style lang="scss" module>
  #users {
    .body {
      display: flex;
      align-items: flex-start;

      .block {
        flex-grow: 3;
        margin-top: 30px;
        padding: 20px 20px 40px;
        background-color: white;
        border-radius: 8px;
        -webkit-box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);
        box-shadow: 0 2px 4px 0 rgba(14, 30, 37, 0.12);

        &:first-child {
          margin-right: 10px;
        }

        &.short {
          max-width: 400px;
          flex-grow: 1;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Users/index.vue